
import React from 'react';
import './TableAnswers.scss';
import { openInputForms, openDeleteInputFormsForAnswers  } from '../../../../adminSlice';

export default class TableAnswers extends React.Component {
    constructor(props) {
        super(props);

       this.onEdit = this.onEdit.bind(this);
       this.onDelete = this.onDelete.bind(this);
       
    }

onEdit(e) {
    const { dispatch } = this.props;

    const id = e.target.value;
    console.log(id);
    dispatch(openInputForms(id));

}
onDelete(e) {
    const { dispatch } = this.props;

    const id = e.target.value;
    dispatch(openDeleteInputFormsForAnswers(id));

}

   renderTable() {
    let  data =  this.props.data;
    return (
        data.map(item => {
           // console.log(item.id + " " + item.label);
            return(
                
                    <tr key={item.id}>
                        <td>{item.id}</td>
                        <td><button  className='bigbtn' value={item.id}>{item.text}</button>
                        <p>значение {item.value}</p>
                        <div className='edit'>
                         <button className='smallbtnEdit'  value={item.id} onClick={this.onEdit} ></button>
                         <button className='smallbtnDelete' value={item.id} onClick={this.onDelete} ></button>
                        </div>
                         </td>
                    </tr>
                    
                

                )
            })
        )    
   }
   
    render() {

      //  const data = this.props.data;

        return(
            <div className="TableAnswers">
                
                <table>
                    <thead>
                        <tr>
                            <th>№</th>
                            <th>Ответ</th>
                        </tr>
                        
                    </thead>
                    <tbody>
                    {this.renderTable()}
                    
                    
                    </tbody>
                
                    
                    

                </table>
                
            </div>
        )
    }
}